
//override Customer:Hub link hijacking for sharepoint links
// Prevent CustomerHub from hijacking SharePoint links only
// Leaves all other rewritten links (legitimate internal / protected ones) alone
document.addEventListener('DOMContentLoaded', () => {

    const bypassHubForSharePoint = (event) => {
        // Early exit: only interested in links that CustomerHub rewrote
        if (!event.target.matches('a[href*="/a/customerhub"]')) {
            return;
        }

        const link = event.target.closest('a');
        if (!link) return;

        // This is the URL CustomerHub stored before rewriting
        let originalUrl = link.getAttribute('data-original-href') || '';

        // Only continue if this is actually a SharePoint link
        if (!originalUrl.includes('sharepoint.com')) {
            return;   // ← important: protects other legitimate rewrites
        }

        // Fix duplicated URL pattern sometimes seen (https...https...)
        if (originalUrl.includes('https://', 30)) {
            const parts = originalUrl.split('https://');
            if (parts.length >= 3) {
                // keep only first + second part → removes second full URL
                originalUrl = parts[0] + 'https://' + parts[1];
            }
        }

        // Safety: make sure we still have a valid-looking sharepoint link
        if (!originalUrl.includes('sharepoint.com')) {
            return;
        }

        // Stop CustomerHub's handler(s) from running
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        // Open in new tab (recommended for PDFs / spec sheets)
        window.open(originalUrl, '_blank', 'noopener,noreferrer');

        // If you prefer opening in the same tab, uncomment this instead:
        // window.location.href = originalUrl;
    };

    // Use capture phase (true) → run before CustomerHub's listener
    document.addEventListener('click',     bypassHubForSharePoint, true);
    document.addEventListener('auxclick',  bypassHubForSharePoint, true);  // middle click
    document.addEventListener('contextmenu', bypassHubForSharePoint, true); // right click (optional)

});